import * as amplitude from '@amplitude/analytics-browser';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { RuntimeLoader } from '@rive-app/canvas';
import { filter, takeWhile, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { OnboardingFlowService } from './services/onboarding-flow.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterOutlet],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    isLogoShown: boolean = true;
    isFullScreen: boolean = false;
    isActive: boolean = true;

    backgroundStyle: { [key: string]: string } = {};
  
    constructor(private router: Router, private flowService: OnboardingFlowService) {}
  
    ngOnInit(): void {
      this.isLogoShown = !this.router.url.includes('checkout');
      this.isFullScreen = this.router.url.includes('start') || this.router.url.includes('checkout');
  
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
            this.isLogoShown = !this.router.url.includes('checkout');
            this.isFullScreen = this.router.url.includes('start') || this.router.url.includes('checkout');
        }),
        takeWhile(() => this.isActive),
      ).subscribe();

      this.flowService.fullScreenBackgroundImage$
        .pipe(
          tap(imageUrl => {
            if (imageUrl) {
              this.backgroundStyle = {
                // 'background-image': `url(${imageUrl})`,
                // 'background-size': 'cover',
                // 'background-position': 'top center',
                'background': `linear-gradient(to bottom, var(--brown100), rgba(128,128,128,0) 30%),
                               linear-gradient(to top, var(--brown100), rgba(128,128,128,0) 40%),
                               url(${imageUrl}) center / cover no-repeat`,
              };
            } else {
              this.backgroundStyle = {};
            }
          }),
          takeWhile(() => this.isActive),
        )
        .subscribe();
  
      this.startAnalytics();

      RuntimeLoader.setWasmUrl('lib/rive.wasm');
    }
  
    startAnalytics() {
      amplitude.init(environment.amplitudeKey, {
        defaultTracking: true,
        appVersion: environment.appVersion,
        autocapture: {
          pageViews: false,
        }
      });
  
      // const experiment = this.abService.getExperiment('order_of_goal_screen_in_the_flow');  //is_goal_screen_first
      // const isGoalScreenFirst = experiment.get('is_goal_screen_first', false);
  
      // this.abService.setConfigProperty({
      //   isGoalScreenFirst: isGoalScreenFirst,
      // });
  
      amplitude.track({
        event_type: 'web_onboarding_started',
        user_properties: {
          web_onboarding_version: environment.appVersion,
          //[`web_statsig_goal_flow_order`]: isGoalScreenFirst ? 'first' : 'tenth',
        }
      });
  
      //this.abService.logEvent('test_init');
    }
  
    ngOnDestroy(): void {
      this.isActive = false;
    }
}